// lib/gtag.js

export const GA_TRACKING_ID = 'G-HKJQ5TPVPC'

// Map a route path to a stable, lowercase, English screen_name slug
// (kept identical in spirit to the app *_view screen slugs).
export const screenNameFromPath = (url) => {
  if (!url) return 'home'
  // strip query/hash and locale prefix (/ko, /ja, /en)
  const path = url.split('?')[0].split('#')[0].replace(/^\/(ko|ja|en)(?=\/|$)/, '')
  const clean = path.replace(/^\/+|\/+$/g, '')
  if (clean === '') return 'home'
  const map = {
    invite: 'invite',
    'referral-event': 'referral_event',
    'redirect-link': 'redirect_link',
    notice: 'notice',
    'notice/detail': 'notice_detail',
    privacy: 'privacy',
    'clause-privacy': 'clause_privacy',
    'terms-of-service': 'terms_of_service',
  }
  return map[clean] || clean.replace(/[\/-]/g, '_')
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  })
  // Additive: also emit screen_name alongside the existing page_view so
  // app + web share the same stable English screen slug taxonomy.
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('set', { screen_name: screenNameFromPath(url) })
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}

// Thin GA4 wrapper for unified-spec events that use raw event names + snake_case params
// (e.g. GA4-reserved `share`, and custom `app_download_click` / `referral_click` / `outbound_click`).
// Keeps `event()` above untouched (additive only). Drops undefined/null params so reports stay clean.
export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  const clean = {}
  Object.keys(params).forEach((key) => {
    const v = params[key]
    if (v !== undefined && v !== null) {
      clean[key] = v
    }
  })
  window.gtag('event', name, clean)
}

// GA4 user properties — identical keys across platforms
// (country, language, login_provider, step_mode, referral_source).
export const setUserProperties = (props = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  const clean = {}
  Object.keys(props).forEach((key) => {
    const v = props[key]
    if (v !== undefined && v !== null) {
      clean[key] = v
    }
  })
  if (Object.keys(clean).length === 0) return
  window.gtag('set', 'user_properties', clean)
}
